// extracted by css-extract-rspack-plugin
export default {"cls1":"StatCells-cls1_d73","cls2":"StatCells-cls2_Cvx StatCells-cls1_d73","layout-stacked":"StatCells-layout-stacked_nfR","layout-inline":"StatCells-layout-inline_LSW"};